@if (state$ | async; as state) {
  @if (inProgress$ | async) {
    <mat-progress-bar
      mode="indeterminate"
      color="primary"
      class="progress-bar"
    />
  }
  <header mat-dialog-title>
    @if ((state$ | async)?.dialogIcon; as icon) {
      <mat-icon class="dialog-icon">{{ icon }}</mat-icon>
    }
    {{ data.projectName }}
  </header>
  <app-debugger-group>
    <app-debugger title="projectMap" [json]="projectMap$" />
    <app-debugger title="project" [json]="project$" />
    <app-debugger title="state" [json]="state$" />
    <app-debugger title="data" [json]="data" />
  </app-debugger-group>

  <mat-dialog-content fxLayout="column">
    @if (terminalStateMessage$ | async; as terminalStateMessage) {
      @if ((inErrorState$ | async) ?? false; as inErrorState) {
        <app-information-box [warning]="inErrorState">
          <p>An error occurred.</p>
          <p>
            Please try again later or
            <a href="mailto:helpdesk@syrf.org.uk">contact us</a> for help.
          </p>
        </app-information-box>
      } @else {
        @for (paragraph of terminalStateMessage.split('\n'); track paragraph) {
          <p>
            {{ paragraph }}
          </p>
        }
      }
      @if (terminalStateInfoBoxMessage$ | async; as terminalStateInfo) {
        <app-information-box>
          @for (paragraph of terminalStateInfo.split('\n'); track paragraph) {
            <p>
              {{ paragraph }}
            </p>
          }
        </app-information-box>
      }
      @if (state?.joinProjectError; as joinProjectError) {
        <div>
          {{ joinProjectError }}
        </div>
      }
    } @else {
      @if (
        state?.invitationInfo?.state ===
        InvitationStatus.claimedByAnotherAccount
      ) {
        <app-information-box warning>
          <p>
            This invitation was sent to an email address that is linked with a
            different SyRF account.
          </p>
          <p>
            @switch (state.joinProjectState) {
              @case (JoinProjectState.requestRequired) {
                To join the project click request to join below.
              }
              @case (JoinProjectState.autoApproval) {
                However, you can join this project with the signed in account by
                clicking join below.
              }
              @case (JoinProjectState.requestPending) {
                A request to join from the signed in account is currently
                pending approval.
              }
              @case (JoinProjectState.invited) {
                However, you can join this project with the signed in account by
                accepting the invitation below.
              }
            }
          </p>
          <p>
            If you want to accept the invitation from the account associated
            with the email address
            <strong>{{ state?.invitationInfo?.email }}</strong>
            <a (click)="signInWithCorrectAccount()" style="cursor: pointer"
              ><strong> sign out and sign in with that account</strong>.</a
            >
          </p>
        </app-information-box>
      }
      @if (state?.invitationInfo?.state === InvitationStatus.unclaimed) {
        <app-information-box [warning]>
          This invitation was sent to an email address not yet linked with this
          account. Before you can accept the invitation,
          <a
            (click)="
              associateEmailAddress(
                $safeNavigationMigration(data.invitationInfo?.email)
              )
            "
            style="cursor: pointer"
            ><em>associate the email address with this SyRF account</em>.</a
          >.
        </app-information-box>
      }
      <app-information-box>
        @if (state?.mainMessage) {
          @for (paragraph of state.mainMessage.split('\n'); track paragraph) {
            <p>
              {{ paragraph }}
            </p>
          }
        }
        @if (state?.entityUserMessage; as userMessage) {
          <div fxLayout="row" class="message-quote">
            <mat-icon class="quote-icons flip-x" fxFlexAlign="start"
              >format_quote
            </mat-icon>
            <div>{{ userMessage }}</div>
            <mat-icon class="quote-icons" fxFlexAlign="end"
              >format_quote</mat-icon
            >
          </div>
        }
      </app-information-box>
      <div class="project-info">
        <h2>Description</h2>
        <p class="preline">{{ data.description | newline: 2 }}</p>
        <h2>Project Access</h2>
        <p>{{ state?.projectAccess }}</p>
        <h2>Owner</h2>
        <p>{{ data.owner | fullName }}</p>
      </div>
      @if (data.recordReason && (notInTerminalState$ | async)) {
        <mat-form-field>
          <mat-label>Message to project admins (optional)</mat-label>
          <textarea
            matInput
            [(ngModel)]="message"
            [disabled]="(inProgress$ | async) ?? false"
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            cdkAutosizeMaxRows="5"
          ></textarea>
        </mat-form-field>
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions
    fxLayout="row"
    fxLayoutAlign="end center"
    fxLayoutGap="10px"
  >
    @if (notInTerminalState$ | async) {
      <button
        mat-button
        cdkFocusInitial
        [mat-dialog-close]="JoinProjectDialogResult.dismiss"
      >
        CLOSE
      </button>
    }
    @if (inTerminalState$ | async) {
      <button
        mat-raised-button
        color="primary"
        cdkFocusInitial
        [mat-dialog-close]="JoinProjectDialogResult.dismiss"
      >
        OK
      </button>
    }
    @if (notInTerminalState$ | async) {
      @if (data?.negativeActivity) {
        <button
          mat-flat-button
          color="warn"
          (click)="action(data.negativeActivity)"
          [disabled]="(inProgress$ | async) ?? false"
        >
          {{
            $safeNavigationMigration(data.negativeActivity?.buttonText)
              | uppercase
          }}
        </button>
      }
      @if (data.positiveActivity) {
        <button
          mat-raised-button
          color="primary"
          [disabled]="(inProgress$ | async) ?? false"
          (click)="action(data.positiveActivity)"
        >
          {{ data.positiveActivity.buttonText | uppercase }}
        </button>
      }
    }
  </mat-dialog-actions>
}
